import { render, staticRenderFns } from "./suporte-usuarios.vue?vue&type=template&id=31443aad&scoped=true"
import script from "./suporte-usuarios.vue?vue&type=script&lang=ts"
export * from "./suporte-usuarios.vue?vue&type=script&lang=ts"
import style0 from "./suporte-usuarios.vue?vue&type=style&index=0&id=31443aad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31443aad",
  null
  
)

export default component.exports